import {SelectionMode} from 'components/FluentUICompat';
import React, {useMemo} from 'react';
import {
	AssignedRequirementFilterOptions,
	Requirement,
	RequirementFilterOptions,
	VehicleProject,
} from 'types';
import {
	InfinityList,
	InfinityListFilter,
	InfinityListItemWithId,
	InfinityListView,
} from 'components/InfinityList';
import {useNavigate, useParams} from 'react-router-dom';
import {
	filters2MongoQuerySTD,
	useInfinityListStandardHooks,
} from 'components/InfinityList/InfinitListStandardHooks';
import {
	assignedReqFields,
	AssignedRequirementWithID,
	resolveVehicleProjects,
	useAssignedRequirementColumnMetaData,
	useAssignedRequirementsColumn,
	useAssignedRequirementRowStyles,
	useAssignedRequirementsPageFilterOptions,
} from './AssignedRequirementColumns';

const initialSortField = 'name';
const initialSortOrder = 'ASC';
const intBatchSize = 50;

export type QueryDocumentsDBArg = {
	queryReq: string;
	queryAssignedReq: string;
};

type AssignedRequirementsTabProps = {
	loadingQuery: boolean;
	loadingDocuments: boolean;
	hidden: boolean;
	arrIds: string[];
	requirementFilterOptions?: RequirementFilterOptions;
	assignedRequirementFilterOptions?: AssignedRequirementFilterOptions;
	dictVehicleProjects: Record<string, VehicleProject>;
	queryDocumentsDB: (
		query: any,
		sortField: string,
		sortOrder: string,
		preFilteredIds?: string[],
	) => Promise<{
		arrDocumentNext: AssignedRequirementWithID[];
		arrIDsNew: string[];
	}>;
	getDocumentsNextDB: (
		preFilteredIds: string[],
	) => Promise<AssignedRequirementWithID[]>;
	getSortOrderDB: (
		preFilteredIds: string[],
		sortField: string,
	) => Promise<string[]>;
};
export const AssignedRequirementsList: React.FC<
	AssignedRequirementsTabProps
> = ({
	loadingQuery,
	loadingDocuments,
	hidden,
	arrIds,
	requirementFilterOptions,
	assignedRequirementFilterOptions,
	dictVehicleProjects,
	queryDocumentsDB,
	getDocumentsNextDB,
	getSortOrderDB,
}) => {
	const columns = useAssignedRequirementsColumn();
	const columnMetaData = useAssignedRequirementColumnMetaData();
	const columnFilterOptions = useAssignedRequirementsPageFilterOptions(
		dictVehicleProjects,
		requirementFilterOptions,
		assignedRequirementFilterOptions,
	);
	const getRowStyles = useAssignedRequirementRowStyles();
	const navigate = useNavigate();

	const views: InfinityListView[] = useMemo(() => [], []);

	const initialView = 'STD';

	const combineViewAndUserFilterQuery = (
		queryUser: QueryDocumentsDBArg,
		views: InfinityListView[],
		viewKey?: string,
	) => {
		return queryUser;
	};

	const filters2MongoQuery = (allFilters: InfinityListFilter[]) => {
		const filters2MongoReq = filters2MongoQuerySTD(
			columns.filter(x => !assignedReqFields.includes(x.key)),
			columnMetaData.filter(x => !assignedReqFields.includes(x.key)),
		);
		const filters2MongoAssignedReq = filters2MongoQuerySTD(
			columns.filter(x => assignedReqFields.includes(x.key)),
			columnMetaData.filter(x => assignedReqFields.includes(x.key)),
		);
		const queryReq = filters2MongoReq(allFilters);
		const queryAssignedReq = filters2MongoAssignedReq(allFilters);
		return {queryReq, queryAssignedReq};
	};

	const {
		arrDocument,
		keyPrefix,
		linksFilters,
		firstRenderSTD,
		applyFilterSTD,
		applySortSTD,
		loadItemsNextSTD,
	} = useInfinityListStandardHooks({
		views,
		intBatchSize,
		initialSortField,
		initialSortOrder,
		initialView,
		arrIds,
		generateLink: false,
		columns,
		columnMetaData,
		filters2MongoQuery,
		combineViewAndUserFilterQuery,
		queryDocumentsDB,
		getDocumentsNextDB,
		getSortOrderDB,
	});

	const handleViewingItem = (item: Requirement) => {
		navigate({
			pathname: `/requirements/${item.id}`,
		});
	};

	const numberOfElements = useMemo(() => arrIds.length, [arrIds]);

	const createHref = (item: unknown) =>
		`/requirements/${(item as InfinityListItemWithId).id}`;

	const arrDocumentFinal = useMemo(
		() => arrDocument.map(x => resolveVehicleProjects(x, dictVehicleProjects)),
		[arrDocument, dictVehicleProjects],
	);

	return (
		<>
			{!hidden && (
				<InfinityList
					pageName={''}
					items={arrDocumentFinal}
					sticky={true}
					columns={columns}
					columnMetaData={columnMetaData}
					columnFilterOptions={columnFilterOptions}
					selectionMode={SelectionMode.multiple}
					stillLoading={loadingQuery || loadingDocuments}
					initalFilters={linksFilters}
					initialSortField={initialSortField}
					initialSortOrder={initialSortOrder}
					initialView={initialView}
					keyPrefix={keyPrefix}
					firstRender={firstRenderSTD}
					loadItemsNext={loadItemsNextSTD}
					applyFilter={applyFilterSTD}
					applySort={applySortSTD}
					handleInvokeItem={handleViewingItem}
					createHref={createHref}
					numberOfElements={numberOfElements}
					showHeader={false}
					views={views}
					advancedFilterShow={false}
					getRowStyles={getRowStyles}
				/>
			)}
		</>
	);
};
